<template>
 <div v-bind:style="styles" id="Pgwrp" ref="Pgwrp">
  <div
    v-if="profile.name == 'School Admin'"
    id="page-container"
    class="sidebar-partial sidebar-no-animations sidebar-visible-lg"
  >
    <div id="sidebar">
      <div class="logo">
        <h1>
          <img src="../assets/img/smallLogo.jpg" width="60px" />
          <span>VIDHYAAN</span>
        </h1>
      </div>
      <div class="sideprofile">
        <!--<img src="../../assets/img/img_avatar.png" alt="Avatar" class="avatar"> <p>Vimal</p>-->
      </div>
      <nav class="navbar">
        <!-- Links -->
        <ul class="navbar-nav">
          <li
            class="nav-item"
            :class="{ active: isTabSelected('/enrollment/school') }"
            v-if="version == 'freeVersion'"
          >
            <a
              class="nav-link"
              @click.prevent="redirectRoute('/enrollment/school')"
              href="javascript:void(0)"
              ><i class="fas fa-school"></i>
              <p>Enroll School</p></a
            >
          </li>
          <!-- <li
            class="nav-item"
            :class="{ active: isTabSelected('/admission/admissionOnline') }"
            v-if="version == 'freeVersion'"
          >
            <a
              class="nav-link"
              @click.prevent="redirectRoute('/admission/admissionOnline')"
              href="javascript:void(0)"
              ><i
                class="fas fa-globe"
                aria-hidden="true"
                style="font-size: 1.2rem; margin-top: 3px"
              ></i>
              <p>Online Admission</p></a
            >
          </li> -->
          <li
            class="nav-item"
            :class="{ active: isTabSelected('/enrollment/setting') }"
            v-if="version == 'freeVersion'"
          >
            <a
              class="nav-link"
              @click.prevent="redirectRoute('/enrollment/setting')"
              href="javascript:void(0)"
              ><i class="fas fa-cog"></i>
              <p>Settings</p></a
            >
          </li>
          
          <li 
            class="nav-item"
            :class="{ active: isTabSelected('/admission/home') }"
            v-if="version == 'paidVersion'"
          >
            <a   :style="currentPlanDetails && currentPlanDetails != 'live' && currentPlanDetails != 'dunning' ? 'cursor: not-allowed;pointer-events: none;color: darkgray' : 'pointer-events: visible;'"
              class="nav-link"
              @click="redirectRoute('/admission/home')"
              href="javascript:void(0)"
              ><i class="fas fa-clipboard-list"></i>
              <p :style="currentPlanDetails && currentPlanDetails != 'live' && currentPlanDetails != 'dunning' ? 'color: darkgray' : ''">Admission Mgmt</p></a
            >
          </li>
           <li 
            class="nav-item"
            :class="{ active: isTabSelected('/admission/alertsAndNotifications') }"
            v-if="version == 'paidVersion'"
          >
            <a   :style="currentPlanDetails && currentPlanDetails != 'live' && currentPlanDetails != 'dunning' ? 'cursor: not-allowed;pointer-events: none;color: darkgray' : 'pointer-events: visible;'"
              class="nav-link"
              @click="redirectRoute('/admission/alertsAndNotifications')"
              href="javascript:void(0)"
              ><i class="fa fa-bell" aria-hidden="true"></i>
              <p :style="currentPlanDetails && currentPlanDetails != 'live' && currentPlanDetails != 'dunning' ? 'color: darkgray' : ''">Alerts & Notifications</p></a
            >
          </li>
          <li
            class="nav-item"
            :class="{ active: isTabSelected('/admission/dashboard') }"
            v-if="version == 'paidVersion'"
          >
            <a :style="currentPlanDetails && currentPlanDetails != 'live' && currentPlanDetails != 'dunning' ? 'cursor: not-allowed;pointer-events: none;color: darkgray' : 'pointer-events: visible;'"
              class="nav-link" 
              @click.prevent="redirectRoute('/admission/dashboard')"
              href="javascript:void(0)"
              ><i
                class="fas fa-chart-pie"
                aria-hidden="true"
                style="font-size: 1.2rem; margin-top: 3px"
              ></i>
              <p :style="currentPlanDetails && currentPlanDetails != 'live' && currentPlanDetails != 'dunning' ? 'color: darkgray' : ''">Dashboard</p></a
            >
          </li>
          <li
            class="nav-item"
            :class="{ active: isTabSelected('/admission/admissionOnline') }"
            v-if="version == 'paidVersion'"
          >
            <a :style="currentPlanDetails && currentPlanDetails != 'live' && currentPlanDetails != 'dunning' ? 'cursor: not-allowed;pointer-events: none;color: darkgray' : 'pointer-events: visible;'"
              class="nav-link"
              @click.prevent="redirectRoute('/admission/admissionOnline')"
              href="javascript:void(0)"
              ><i
                class="fas fa-globe"
                aria-hidden="true"
                style="font-size: 1.2rem; margin-top: 3px"
              ></i>
              <p :style="currentPlanDetails && currentPlanDetails != 'live' && currentPlanDetails != 'dunning' ? 'color: darkgray' : ''">Online Admission</p></a
            >
          </li>
          <li
            class="nav-item"
            :class="{ active: isTabSelected('/admission/online/request/tc') }"
            v-if="version == 'paidVersion'"
          >
            <a :style="currentPlanDetails && currentPlanDetails != 'live' && currentPlanDetails != 'dunning' ? 'cursor: not-allowed;pointer-events: none;color: darkgray' : 'pointer-events: visible;'"
              class="nav-link"
              @click.prevent="redirectRoute('/admission/online/request/tc')"
              href="javascript:void(0)"
              ><i
                class="fas fa-mobile-alt"
                aria-hidden="true"
                style="font-size: 1.2rem; margin-top: 3px"
              ></i>
              <p :style="currentPlanDetails && currentPlanDetails != 'live' && currentPlanDetails != 'dunning' ? 'color: darkgray' : ''">CERTIFICATE REQUEST</p></a
            >
          </li>
          <li
            class="nav-item"
            :class="{ active: isTabSelected('/feesManagement/home') }"
            v-if="version == 'paidVersion'"
          >
            <a :style="currentPlanDetails && currentPlanDetails != 'live' && currentPlanDetails != 'dunning' ? 'cursor: not-allowed;pointer-events: none;color: darkgray' : 'pointer-events: visible;'"
              class="nav-link"
              @click.prevent="redirectRoute('/feesManagement/home')"
              href="javascript:void(0)"
              ><i class="fas fa-receipt"></i>
              <p :style="currentPlanDetails && currentPlanDetails != 'live' && currentPlanDetails != 'dunning' ? 'color: darkgray' : ''">Fees Management</p></a
            >
          </li>
          <!-- <li
            class="nav-item"
            :class="{ active: isTabSelected('/feesManagement/report') }"
            v-if="version == 'paidVersion'"
          >
            <a class="nav-link" href="reports.html"
              ><i class="fa fas fa-chart-bar" aria-hidden="true"></i>
              <p>Reports</p></a
            >
          </li> -->
          <li
            class="nav-item"
            :class="{ active: isTabSelected('/admission/ImportExp') }"
            v-if="version == 'paidVersion'"
          >
            <a :style="currentPlanDetails && currentPlanDetails != 'live' && currentPlanDetails != 'dunning' ? 'cursor: not-allowed;pointer-events: none;color: darkgray' : 'pointer-events: visible;'"
              class="nav-link"
              @click.prevent="redirectRoute('/admission/ImportExp')"
              href="javascript:void(0)"
              ><i
                class="fas fa-exchange-alt"
                aria-hidden="true"
                style="transform: rotate(90deg)"
              ></i>
              <p :style="currentPlanDetails && currentPlanDetails != 'live' && currentPlanDetails != 'dunning' ? 'color: darkgray' : ''">Import/Export</p></a
            >
          </li>
          <li
            class="nav-item"
            :class="{ active: isTabSelected('/admission/promote/students') }"
            v-if="version == 'paidVersion'"
          >
            <a :style="currentPlanDetails && currentPlanDetails != 'live' && currentPlanDetails != 'dunning' ? 'cursor: not-allowed;pointer-events: none;color: darkgray' : 'pointer-events: visible;'"
              class="nav-link"
              @click.prevent="redirectRoute('/admission/promote/students')"
              href="javascript:void(0)"
            >
              <i class="fas fa-user-graduate"></i>
              <p :style="currentPlanDetails && currentPlanDetails != 'live' && currentPlanDetails != 'dunning' ? 'color: darkgray' : ''">Promote Students</p></a
            >
          </li>
           <li
              class="nav-item"
              :class="{ active: isTabSelected('/academic/academicManagement') }"
            >
              <a
                class="nav-link"
                @click.prevent="redirectRoute('/academic/academicManagement')"
                href="javascript:void(0)"
                ><i class="fas fa-clipboard-list"></i>
                <p>Academic Management</p></a
              >
            </li>
          <li
            class="nav-item"
            :class="{ active: isTabSelected('/vidhyaan/feature/request') }"
            v-if="version == 'paidVersion'"
          >
            <a
              class="nav-link"
              @click.prevent="redirectRoute('/vidhyaan/feature/request')"
              href="javascript:void(0)"
              ><i class="fa fa-th-large"></i>
              <p>FEATURE REQUEST</p></a
            >
          </li>
          <li
            class="nav-item"
            :class="{ active: isTabSelected('/admission/admissionSettings') }"
            v-if="version == 'paidVersion'"
          >
            <a
              class="nav-link"
              @click.prevent="redirectRoute('/admission/admissionSettings')"
              href="javascript:void(0)"
              ><i class="fas fa-cog"></i>
              <p>Settings</p></a
            >
          </li>
          
          
        </ul>
      </nav>
    </div>
    <div id="main-container">
      <NavBar />
      <div class="pgwrapper" id="pgwrapper">
        <router-view></router-view>
      </div>
      <div style="margin-left: 24px">&copy; Vidhyaan.</div>
    </div>
  </div>

  <div
    v-else-if="profile.name == 'Parent'"
    id="page-container"
    :class="$route.path == '/parent/search/home' || $route.path == '/parent/search-school' ? 'sidebar-no-animations prntsidebar-visible-lg' : 'sidebar-partial sidebar-no-animations prntsidebar-visible-lg'"
  >
    <div
      v-if="
        profile.name == 'Parent' &&
        $route.path != '/parent/search/home' &&
        $route.path != '/parent/search-school'
      "
      id="page-container"
      class="sidebar-partial sidebar-no-animations prntsidebar-visible-lg"
    >
      <div
        id="sidebar"
        v-if="
          $route.path != '/parent/search/home' &&
          $route.path != '/parent/search-school'
        "
      >
        <div class="logo">
          <h1>
            <img src="../assets/img/smallLogo.jpg" width="60px" />
            <span @click="goBackVidhyan">VIDHYAAN</span>
          </h1>
        </div>
        <div class="sideprofile">
          <!--<img src="../../assets/img/img_avatar.png" alt="Avatar" class="avatar"> <p>Vimal</p>-->
        </div>
        <nav class="navbar">
          <!-- Links -->
          <ul class="navbar-nav">
           
            <li  v-if="!showStudentProfile"
              class="nav-item"
              :class="{ active: isTabSelected('/parent/home') }"
            >
              <a
                class="nav-link"
                @click.prevent="redirectRoute('/parent/home')"
                href="javascript:void(0)"
                ><i class="fas fa-home"></i>
                <p>Home</p></a
              >
            </li>
            <li  v-if="!showStudentProfile"
              class="nav-item"
              :class="{ active: isTabSelected('/parent/admission') }"
            >
              <a
                class="nav-link"
                @click.prevent="redirectRoute('/parent/admission')"
                href="javascript:void(0)"
                ><i class="fas fa-clipboard-list"></i>
                <p>Admission</p></a
              >
            </li>
            <li v-if="showStudentProfile && studentInformation.length > 0 && studentInformation[0].school.version == 'paidVersion'"
              class="nav-item"
              :class="{ active: isTabSelected(`/parent/student/home/${studentInformation[0]._id}`) }"
            >
              <a
              @click.prevent="redirectRoute(`/parent/student/home/${studentInformation[0]._id}`)"
             
                class="nav-link"
                href="javascript:void(0)"
                ><i class="fas fa-home"></i>
                <p>Home</p></a
              >
            </li>
            <li v-if="showStudentProfile && studentInformation.length > 0 && studentInformation[0].school.version == 'paidVersion'"
              class="nav-item"
              :class="{ active: isTabSelected(`/parent/student/portal/view/details/${studentInformation[0]._id}`) }"
            >
              <a
              @click.prevent="redirectRoute(`/parent/student/portal/view/details/${studentInformation[0]._id}`)"
             
                class="nav-link"
                href="javascript:void(0)"
                ><i class="fas fa-user-graduate"></i>
                <p>Student Profile</p></a
              >
            </li>
            
            <li v-if="showStudentProfile && studentInformation.length > 0 && studentInformation[0].school.version == 'paidVersion'"
              class="nav-item"
              :class="{ active: isTabSelected(`/parent/student/feePayment/${studentInformation[0]._id}`) }"
            >
              <a
                @click.prevent="redirectRoute(`/parent/student/feePayment/${studentInformation[0]._id}`)"
                class="nav-link"
                href="javascript:void(0)"
                ><i class="fas fa-receipt"></i>
                <p>Fee Payment</p></a
              >
            </li>
              <li v-if="showStudentProfile && studentInformation.length > 0 && studentInformation[0].school.version == 'paidVersion'"
              class="nav-item"
              :class="{ active: isTabSelected(`/parent/student/alerts/${studentInformation[0]._id}`) }"
            >
              <a
              @click.prevent="redirectRoute(`/parent/student/alerts/${studentInformation[0]._id}`)"
                class="nav-link"
                href="javascript:void(0)"
                ><i class="fas fa-bell"></i>
                <p>Alerts & Notifications</p></a
              >
            </li>
            <li v-if="showStudentProfile && studentInformation.length > 0 && studentInformation[0].school.version == 'paidVersion'"
              class="nav-item"
              :class="{ active: isTabSelected(`/parent/student/paymentHistory/${studentInformation[0]._id}`) }"
            >
              <a
                 @click.prevent="redirectRoute(`/parent/student/paymentHistory/${studentInformation[0]._id}`)"
                class="nav-link"
                href="javascript:void(0)"
                ><i class="fas fa-file-invoice"></i>
                <p>Payment History</p></a
              >
            </li>
            <li v-if="showStudentProfile && studentInformation.length > 0 && studentInformation[0].school.version == 'paidVersion'"
              class="nav-item"
              :class="{ active: isTabSelected(`/parent/student/tc/${studentInformation[0]._id}`) }"
            >
              <a
                @click.prevent="redirectRoute(`/parent/student/tc/${studentInformation[0]._id}`)"
                class="nav-link"
                href="javascript:void(0)"
                ><i class="fas fa-file-alt"></i>
                <p>CERTIFICATE REQUEST</p></a
              >
            </li>
             <li v-if="showStudentProfile && studentInformation.length > 0 && studentInformation[0].school.version == 'paidVersion'"
              class="nav-item"
              :class="{ active: isTabSelected(`/parent/ratingAndReview/school/${studentInformation[0]._id}`) }"
            >
              <a
                @click.prevent="redirectRoute(`/parent/ratingAndReview/school/${studentInformation[0]._id}`)"
                class="nav-link"
                href="javascript:void(0)"
                ><i class="fas fa-edit"></i>
                <p>REVIEW AND RATINGS </p></a
              >
            </li>
            <li v-if="showStudentProfile && studentInformation.length > 0 && studentInformation[0].school.version == 'paidVersion'"
              class="nav-item"
              :class="{ active: isTabSelected(`/parent/feature/request`) }"
            >
              <a
                @click.prevent="redirectRoute(`/parent/feature/request`)"
                class="nav-link"
                href="javascript:void(0)"
                ><i class="fa fa-th-large"></i>
                <p>FEATURE REQUEST </p></a
              >
            </li>
          

          </ul>
        </nav>
      </div>
    </div>
    <div id="main-container">
      <NavBar />
      <div class="pgwrapper" id="pgwrapper">
        <router-view></router-view>
      </div>
      <div style="margin-left: 24px">&copy; Vidhyaan.</div>
    </div>
  </div>
  <div
    v-else-if="profile.name == 'Teacher'"
    id="page-container"
    :class="$route.path == '/parent/search/home' || $route.path == '/parent/search-school' ? 'sidebar-no-animations prntsidebar-visible-lg' : 'sidebar-partial sidebar-no-animations prntsidebar-visible-lg'"
  >
    <div
      v-if="profile.name == 'Teacher'"
      id="page-container"
      class="sidebar-partial sidebar-no-animations prntsidebar-visible-lg"
    >
      <div
        id="sidebar"
      
      >
        <div class="logo">
          <h1>
            <img src="../assets/img/smallLogo.jpg" width="60px" />
            <span @click="goBackVidhyan">VIDHYAAN</span>
          </h1>
        </div>
        <div class="sideprofile">
          <!--<img src="../../assets/img/img_avatar.png" alt="Avatar" class="avatar"> <p>Vimal</p>-->
        </div>
        <nav class="navbar">
          <!-- Links -->
          <ul class="navbar-nav">
           
            <li
              class="nav-item"
              :class="{ active: isTabSelected('/teacher/home') }"
            >
              <a
                class="nav-link"
                @click.prevent="redirectRoute('/teacher/home')"
                href="javascript:void(0)"
                ><i class="fas fa-home"></i>
                <p>Home</p></a
              >
            </li>
             <li
              class="nav-item"
              :class="{ active: isTabSelected('/teacher/academicManagement') }"
            >
              <a
                class="nav-link"
                @click.prevent="redirectRoute('/teacher/academicManagement')"
                href="javascript:void(0)"
                ><i class="fas fa-clipboard-list"></i>
                <p>Academic Management</p></a
              >
            </li>
             <li
              class="nav-item"
              :class="{ active: isTabSelected('/teacher/examSchedule') }"
            >
              <a
                class="nav-link"
                @click.prevent="redirectRoute('/teacher/examSchedule')"
                href="javascript:void(0)"
                ><i class="fa fa-th-large"></i>
                <p>Exam Schedule</p></a
              >
            </li>
            <li
              class="nav-item"
              :class="{ active: isTabSelected('/teacher/inbox') }"
            >
              <a
                class="nav-link"
                @click.prevent="redirectRoute('/teacher/inbox')"
                href="javascript:void(0)"
                ><i class="fas fa-receipt"></i>
                <p>Inbox</p></a
              >
            </li>
           
          </ul>
        </nav>
      </div>
    </div>
    <div id="main-container">
      <NavBar />
      <div class="pgwrapper" id="pgwrapper">
        <router-view></router-view>
      </div>
      <div style="margin-left: 24px">&copy; Vidhyaan.</div>
    </div>
  </div>
  <div v-else>
    <pricing></pricing>
  </div>

   <vi-spinner
                v-if="viLoader"
                text="Loading..."
                textColor="vi-brand-color"
                class="flex-fill h-100 vi-fs12"
                style="width: 100%;z-index: 111;top:0;left:0;background-color: rgba(255, 255, 255, 0.5);border-radius: 1rem;"
     />
  </div>
</template>
<script>
import NavBar from "@/views/ViNavBar.vue";
import secureUI from "../utils/secureUI";
import ViService from "@/services/ViService";
import ViSpinner from "../components/Common/ViSpinner.vue";

export default {
  name: "vi-admission-home",

  data() {
    return {
      isPayment: true,
      version: "",
      viLoader: false,
      profile: {},
      studentInformation: [],
      showStudentProfile: false
    };
  },
  created() {

	  this.getUserAcountDetails();
  },
  computed: {
      styles(){
       var brwHeight = window.innerHeight;
       return{
         height: (brwHeight - 90) + 'px'
       };
      },
       currentPlanDetails() {
        const details = this.$store.getters.currentPlanDetail;
        if(details){
             return details.status
        }else{
          return 'live'
        }
    },
  },
  methods: {
    isTabSelected(currentPath) {
        let data = localStorage.getItem('activeTab');
        if(data){
               return data.includes(currentPath);
        }else{
          return false
        }

    },
    // setLocalActiveTab(path){
    //   localStorage.setItem("previousTab",path);
    //   localStorage.setItem("activeTab",path);
    // },
    redirectRoute(vipath) {
      let currentRoute = ''
      if(this.$route.path == '/admission/home' || this.$route.path == '/admission/academicYear' || this.$route.path == '/admission/teacher' || this.$route.path == '/admission/department'  || this.$route.path == '/admission/class' || this.$route.path == '/admission/student' || this.$route.path == '/admission/new'){
        currentRoute = '/admission/home'
      }else if(this.$route.path == '/feesManagement/home' || this.$route.path == '/feesManagement/createFeeType' || this.$route.path == '/feesManagement/createPlan' || this.$route.path == '/feesManagement/adhocfees' || this.$route.path == '/feesManagement/paymentGateWay' || this.$route.path == '/feesManagement/invoice/feePlan'){
        currentRoute = '/feesManagement/home'
      }else{
        currentRoute = this.$route.path
      }
      localStorage.setItem("previousTab",currentRoute);
      localStorage.setItem("activeTab",vipath);
      if (this.$route.path !== vipath) this.$router.push({ path: vipath });

    },
    goBackVidhyan() {
      if(!this.showStudentProfile){
         this.$router.push("/parent/search/home");
      }
      
    },
    getUserAcountDetails() {
      
      let userData = secureUI.sessionGet("user");

      if (!userData) {
        this.$toasted.error("Please login and do the action");
        this.$router.push("/login");
      } else {
        this.profile = userData.userDetails.profile;
        this.showStudentProfile = userData.userDetails.isShowStudentProfile

        if (userData.userDetails.profile.name == "School Admin") {
          this.isPayment = userData.userDetails.account.isPayment;
          this.version = userData.userDetails.account.version;

          if(userData.userDetails.profile == 'School Admin' && this.version != 'freeVersion'){
            if(userData.subscription.status != 'live'){

              this.$router.push("/admission/admissionSettings");
            }
          }


          if(this.profile.name == 'Parent'){
           this.getStudentAndSchoolInfo()
          }
        }else{
           if(this.profile.name == 'Parent'){
           this.getStudentAndSchoolInfo()
          }
          
        }
      }
    },
    getStudentAndSchoolInfo() {
      let userData = secureUI.sessionGet("user");

      ViService.viXGet(
        "/contact/getStudentAndSchoolDetails/parent/portal",
        userData.token
      )
        .then((res) => {
          if (res.isSuccess) {
            let data = secureUI.secureGet(res.data);
            if (res.data) {
              this.studentInformation = data;
            }
          } else {
            this.$toasted.show(res.message);
          }
        })
        .catch((e) => {
          let eData = errorLog.apiErrorLog(e);
          this.$toasted.error(eData);
        });
    },
    navigateToSearch() {
      let requestBody = {
        schoolName: null,
        category: null,
        city: null,
      };

      ViService.viPost("/app/school/parentPortal", requestBody)
        .then((res) => {
          if (res.isSuccess) {
            let data = secureUI.secureGet(res.data);
            if (data && data.length > 0) {
              this.$store.dispatch("setSchoolList", data);
              this.$router.push({
                name: "schools",
              });
              this.$router.push("/parent/search-school");
            } else {
              this.$toasted.error("Records not found");
            }
          } else {
            this.$toasted.error(res.message);
          }
        })
        .catch((e) => {
          let eData = errorLog.apiErrorLog(e);
          this.$toasted.error(eData);
        });
    },
  },
  components: {
    NavBar,
    ViSpinner,
    pricing: () => import("./ViPricing.vue"),
  },
};
</script>

<style lang="scss" scoped></style>